import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Flame } from "lucide-react";

export default function StreakLeaderboard() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/admin/streaks").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  if (!items || items.length === 0) return null;

  return (
    <div className="rounded-2xl bg-white border border-orange-100 shadow-sm p-4 mb-5" data-testid="streak-leaderboard">
      <p className="text-xs font-extrabold uppercase text-orange-500 mb-3 flex items-center gap-1.5">
        <Flame className="h-4 w-4" /> Élèves les plus réguliers
      </p>
      <div className="flex flex-wrap gap-2">
        {items.map((s, i) => (
          <div key={s.student_id} data-testid={`streak-leaderboard-item-${i}`}
            className="inline-flex items-center gap-2 bg-orange-50 border border-orange-100 rounded-full px-3 py-1.5">
            <span className="text-xs font-extrabold text-slate-700">{s.name}</span>
            <span className="inline-flex items-center gap-1 text-xs font-extrabold text-orange-600">
              <Flame className="h-3 w-3 fill-orange-500" /> {s.streak_weeks}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
